module.exports = __webpack_public_path__ + "static/media/no1.3d07ca49.webp";